import React from "react";
import RichText from "./RichText";

const FinanceMix = ({ finance }) => {
  if (!finance) return null;
  return (
    <div className="abr-card is-white abr-finance-card">
      <div className="abr-finance-head">
        <div>
          <div className="abr-card-title">Finance mix among matches</div>
          <p className="abr-card-sub" style={{ marginBottom: 0 }}>
            How matched buyers plan to pay, from their stated FinanceType.
          </p>
        </div>
        <RichText as="div" className="abr-finance-right" text={finance.headlineRight} />
      </div>
      <div
        className="abr-finance-bar"
        role="img"
        aria-label={`Finance mix: ${finance.segments.map((s) => `${s.pct} percent ${s.label}`).join(", ")}`}
      >
        {finance.segments.map((seg, idx) => (
          <div
            key={idx}
            className="abr-finance-seg"
            style={{ width: `${seg.pct}%`, background: seg.color }}
          />
        ))}
      </div>
      <div className="abr-finance-legend">
        {finance.segments.map((seg, idx) => {
          const toneClass = seg.tone === "accent"
            ? "abr-finance-pct is-accent"
            : seg.tone === "dim"
              ? "abr-finance-pct is-dim"
              : "abr-finance-pct";
          return (
            <span key={idx}>
              <span className="abr-swatch" style={{ background: seg.color }} />
              <span className={toneClass}>{seg.pct}%</span> {seg.label}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default FinanceMix;
